module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-fff"
  }, [_c('appStatus', {
    attrs: {
      "statusHeight": _vm.statusHeight
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-title",
    style: ({
      top: _vm.statusHeight + 'rem'
    })
  }, [_c('div', {
    staticClass: "color-333 fs-36"
  }, [_vm._v(_vm._s(_vm.countEntity.shopName || _vm.userName))]), _vm._v(" "), _c('div', {
    staticClass: "flex-center"
  }, [(!_vm.isQuarterManageRole && !_vm.isMaintenanceRole) ? _c('div', {
    staticClass: "right-icon alifont icon-refresh click mr-20",
    on: {
      "click": _vm.refreshOrderCount
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isQuarterManageRole && !_vm.isMaintenanceRole) ? _c('div', {
    staticClass: "right-icon alifont icon-xiaoxi click",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'messageList'
        })
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "pd-025"
  }, [(_vm.curNotice) ? _c('div', {
    staticClass: "sys-tip click",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'noticeList'
        })
      }
    }
  }, [_c('div', {
    staticClass: "alifont icon-tongzhi left"
  }), _vm._v(" "), _c('div', {
    staticClass: "text fs-28 text-el"
  }, [_vm._v(_vm._s(_vm.curNotice.title))]), _vm._v(" "), _c('div', {
    staticClass: "alifont icon-fanhui1 right"
  })]) : _vm._e(), _vm._v(" "), (_vm.isQuarterManageRole || _vm.isAdministorRole) ? _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "opc"
  }), _vm._v(" "), (!_vm.isEquipmentApp) ? _c('div', {
    staticStyle: {
      "position": "relative",
      "z-index": "10"
    }
  }, [_c('div', {
    staticClass: "fs-28 color-fff"
  }, [_vm._v("今日销售金额(元)")]), _vm._v(" "), _c('div', {
    staticClass: "sale-money number_font click",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'incomeDetail'
        })
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.formatNumber(_vm.countEntity.salesCount || 0)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "yesterday"
  }, [_vm._v("\n          昨日金额\n          "), _c('span', {
    staticClass: "number_font"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.countEntity.yesterdaySalesCount || 0)))])]), _vm._v(" "), _c('div', {
    staticClass: "flex mt-20"
  }, [_c('div', {
    staticClass: "flex1"
  }, [_c('div', {
    staticClass: "fs-26 color-fff opc-08"
  }, [_vm._v("今日客单价(元)")]), _vm._v(" "), _c('div', {
    staticClass: "fs-36 color-fff number_font"
  }, [_vm._v("\n              " + _vm._s(_vm.formatNumber(_vm.countEntity.atv || 0)) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex1 click",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'orderList'
        })
      }
    }
  }, [_c('div', {
    staticClass: "fs-26 color-fff opc-08"
  }, [_vm._v("今日订单数")]), _vm._v(" "), _c('div', {
    staticClass: "fs-36 color-fff number_font"
  }, [_vm._v("\n              " + _vm._s(_vm.formatNumber(_vm.countEntity.orderCount || 0)) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex1"
  }, [_c('div', {
    staticClass: "fs-26 color-fff opc-08"
  }, [_vm._v("今日售后数")]), _vm._v(" "), _c('div', {
    staticClass: "fs-36 color-fff number_font"
  }, [_vm._v("\n              " + _vm._s(_vm.formatNumber(_vm.countEntity.orderServiceCount || 0)) + "\n            ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isEquipmentApp) ? _c('div', {
    staticStyle: {
      "position": "relative",
      "z-index": "10"
    }
  }, [_c('div', {
    staticClass: "fs-28 color-fff"
  }, [_vm._v("今日销售金额(元)")]), _vm._v(" "), _c('div', {
    staticClass: "sale-money number_font click"
  }, [_vm._v("\n          " + _vm._s(_vm.formatNumber(_vm.countEntity.totalAmountCount || 0)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex mt-20"
  }, [(false) ? _c('div', {
    staticClass: "flex1"
  }, [_c('div', {
    staticClass: "fs-26 color-fff opc-08"
  }, [_vm._v("今日客单价(元)")]), _vm._v(" "), _c('div', {
    staticClass: "fs-36 color-fff number_font"
  }, [_vm._v("\n              " + _vm._s(_vm.formatNumber(_vm.countEntity.atv || 0)) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex1 click"
  }, [_c('div', {
    staticClass: "fs-26 color-fff opc-08"
  }, [_vm._v("今日订单数")]), _vm._v(" "), _c('div', {
    staticClass: "fs-36 color-fff number_font"
  }, [_vm._v("\n              " + _vm._s(_vm.formatNumber(_vm.countEntity.totalOrderCount || 0)) + "\n            ")])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "flex1"
  }, [_c('div', {
    staticClass: "fs-26 color-fff opc-08"
  }, [_vm._v("今日售后数")]), _vm._v(" "), _c('div', {
    staticClass: "fs-36 color-fff number_font"
  }, [_vm._v("\n              " + _vm._s(_vm.formatNumber(_vm.countEntity.orderServiceCount || 0)) + "\n            ")])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "flex1"
  }, [_c('div', {
    staticClass: "fs-26 color-fff opc-08"
  }, [_vm._v("今日异常")]), _vm._v(" "), _c('div', {
    staticClass: "fs-36 color-fff number_font"
  }, [_vm._v("\n              " + _vm._s(_vm.formatNumber(_vm.countEntity.orderServiceCount || 0)) + "\n            ")])]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isAdministorRole || _vm.isStockManagerRole) ? _c('div', {
    staticClass: "flex order-tip fs-32 color-333"
  }, [_c('div', {
    staticClass: "flex1 text-center click left",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'waitSendOrderList'
        })
      }
    }
  }, [_vm._v("\n        待打印\n        "), _c('span', {
    staticClass: "color-red ml-20 number_font"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.orderCountEntity.waitPrintNum || 0)))])]), _vm._v(" "), _c('div', {
    staticClass: "flex1 text-center click left",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'waitSendOrderList'
        })
      }
    }
  }, [_vm._v("\n        待发货\n        "), _c('span', {
    staticClass: "color-main ml-20 number_font"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.orderCountEntity.waitShipNum || 0)))])]), _vm._v(" "), _c('div', {
    staticClass: "flex1 text-center click",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'waitFinishOrderList'
        })
      }
    }
  }, [_vm._v("\n        待完成\n        "), _c('span', {
    staticClass: "color-org ml-20 number_font"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.orderCountEntity.waitReceiveNum || 0)))])])]) : _vm._e(), _vm._v(" "), (_vm.isEquipmentApp || _vm.isQuarterManageRole || _vm.isAdministorRole) ? _c('div', {
    staticClass: "com-content"
  }, [_c('div', {
    staticClass: "fs-36 color-333 font-bold"
  }, [_vm._v("预警")]), _vm._v(" "), _c('div', {
    staticClass: "content-list"
  }, _vm._l((_vm.warningList), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "content-item click",
      on: {
        "click": function($event) {
          return _vm.goUrl(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "fs-28 color-333 mt-10"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isQuarterManageRole || _vm.isMaintenanceRole || _vm.isAdministorRole) ? _c('div', {
    staticClass: "com-content"
  }, [_c('div', {
    staticClass: "fs-36 color-333 font-bold"
  }, [_vm._v("数据管理")]), _vm._v(" "), _c('div', {
    staticClass: "content-list"
  }, _vm._l((_vm.saleDataList), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "content-item click",
      on: {
        "click": function($event) {
          return _vm.goUrl(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "fs-28 color-333 mt-10"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isQuarterManageRole || _vm.isMaintenanceRole || _vm.isAdministorRole) ? _c('div', {
    staticClass: "com-content"
  }, [_c('div', {
    staticClass: "fs-36 color-333 font-bold"
  }, [_vm._v("小区管理")]), _vm._v(" "), _c('div', {
    staticClass: "content-list"
  }, _vm._l((_vm.manageList), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "content-item click",
      on: {
        "click": function($event) {
          return _vm.goUrl(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "fs-28 color-333 mt-10"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isStockManagerRole || _vm.isAdministorRole) ? _c('div', {
    staticClass: "com-content"
  }, [_c('div', {
    staticClass: "fs-36 color-333 font-bold"
  }, [_vm._v("仓库管理")]), _vm._v(" "), _c('div', {
    staticClass: "content-list"
  }, _vm._l((_vm.stockList), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "content-item click",
      on: {
        "click": function($event) {
          return _vm.goUrl(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "fs-28 color-333 mt-10"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isDriverRole || _vm.isSupplierRole || _vm.isAdministorRole) ? _c('div', {
    staticClass: "com-content"
  }, [_c('div', {
    staticClass: "fs-36 color-333 font-bold"
  }, [_vm._v("司机接货")]), _vm._v(" "), _c('div', {
    staticClass: "content-list"
  }, _vm._l((_vm.driverList), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "content-item click",
      on: {
        "click": function($event) {
          return _vm.goUrl(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "fs-28 color-333 mt-10"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isQuarterManageRole || _vm.isAdministorRole || _vm.isMaintenanceRole) ? _c('div', {
    staticClass: "com-content"
  }, [_c('div', {
    staticClass: "fs-36 color-333 font-bold"
  }, [_vm._v("明细分析")]), _vm._v(" "), _c('div', {
    staticClass: "content-list"
  }, _vm._l((_vm.analysisList), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "content-item click",
      on: {
        "click": function($event) {
          return _vm.goUrl(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "fs-28 color-333 mt-10"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "com-content"
  }, [_c('div', {
    staticClass: "fs-36 color-333 font-bold"
  }, [_vm._v("设置")]), _vm._v(" "), _c('div', {
    staticClass: "content-list"
  }, _vm._l((_vm.settingList), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "content-item click",
      on: {
        "click": function($event) {
          return _vm.goUrl(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "fs-28 color-333 mt-10"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])]), _vm._v(" "), _c('img', {
    staticClass: "scan-img click",
    attrs: {
      "src": _vm.scanImg,
      "alt": ""
    },
    on: {
      "click": _vm.scan
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48f97650","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/Home.vue
// module id = 8GUp
// module chunks = 51